import React from 'react';
import Icon from '@ant-design/icons';
import { IIconProps } from './IIconProps';

const TelegramIcon = (props: IIconProps) => {
    return <Icon component={svg} style={{ fontSize: 20, ...props.style }} />;
};
export default TelegramIcon;

const svg = ({ ...props }) => (
    <svg fill='currentColor' {...props} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
        <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round'></g>
        <g id='SVGRepo_iconCarrier'>
            <path d='m12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12c0-6.627-5.373-12-12-12zm5.894 8.221-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z'></path>
        </g>
    </svg>
);
